import { FAQ_GROUPS, FAQS, faqList } from "@/data/faqs";
import { Seo, JsonLd, faqLd } from "@/components/site/Seo";
import { Breadcrumbs, Container, Eyebrow } from "@/components/site/Primitives";
import { FaqList, FinalCta } from "@/components/site/Blocks";

export default function Faqs() {
  const all = Object.entries(FAQS).map(([id, f]) => ({ id, ...f }));
  return (
    <>
      <Seo title="FAQs | Quotes, Bulk Orders, Delivery & Cultural Products | KhozaLand" description="Answers about KhozaLand quotations, custom designs, bulk orders, Ingcawe blankets, Ibhayi lombhaco, production times, deposits and delivery outside Cape Town." path="/faqs" />
      <JsonLd data={faqLd(all)} />
      <section className="bg-white">
        <Container className="pt-6"><Breadcrumbs items={[{ name: "FAQs", path: "/faqs" }]} /></Container>
        <Container className="pb-10 pt-8 lg:pt-12">
          <Eyebrow>Help centre</Eyebrow>
          <h1 className="kl-h1 mt-5">Frequently Asked Questions</h1>
          <p className="mt-6 max-w-2xl text-base leading-7 text-black/70 sm:text-lg">Clear answers about ordering custom printing, branded clothing, gifts and cultural products from KhozaLand.</p>
          <nav aria-label="FAQ topics" className="mt-8 flex flex-wrap gap-2">
            {FAQ_GROUPS.map((g) => (
              <a key={g.title} href={`#${g.title.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="rounded-full border border-black/15 px-4 py-2 text-sm font-medium hover:border-black/40" data-testid={`faq-topic-${g.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}>{g.title}</a>
            ))}
          </nav>
        </Container>
      </section>
      <section className="pb-20">
        <Container className="space-y-14">
          {FAQ_GROUPS.map((g) => (
            <div key={g.title} id={g.title.toLowerCase().replace(/[^a-z]+/g, "-")} className="grid scroll-mt-28 gap-6 lg:grid-cols-12">
              <h2 className="font-display text-2xl tracking-tight lg:col-span-4">{g.title}</h2>
              <div className="lg:col-span-8"><FaqList faqs={faqList(g.keys)} testId={`faq-group-${g.title.toLowerCase().replace(/[^a-z]+/g, "-")}`} /></div>
            </div>
          ))}
        </Container>
      </section>
      <FinalCta title="Still have a question?" text="Ask KhozaLand directly on WhatsApp or send a quotation request." />
    </>
  );
}
